import * as React from 'react';
import {Flex, Grid, Heading, Label} from "@aws-amplify/ui-react";
import AlertCard from "../cards/AlertCard";
import EiaCard from "../cards/EiaCard";
import EiaTable from "./EiaTable";
import Utils from "../../commons/Utils/Utils";
import D4ItemCard from "../d4/D4ItemCard";

const isSmallScreen = Utils.isSmallScreen();

const buttonsColumnEnd = isSmallScreen ? "-1" : "2";
const tableColumnStart = isSmallScreen ? "1" : "2";

const EiaAuctionTableWithButtons = function(props) {

    const {overItemsRightElements, buttons, alert, selectedAuction, selectedAuctionId, setSelectedAuctionId, isLoading, tableData, isMoreDataInBackend, tableHeader, tableInitialState, heading, rowsPerPage, noItemCard} = props;


    const itemCard = !noItemCard && selectedAuction ? <D4ItemCard item={selectedAuction.item} amount={selectedAuction.amount} /> : null;

    let overItemsLeftElements = tableData !== undefined ? <Label>{tableData.length}{isMoreDataInBackend ? "+" : undefined } results</Label> : undefined;

    return(
        <Grid templateColumns="2fr 9fr">
            {alert ? <AlertCard alert={alert} /> : null }
            <EiaCard columnStart="1" columnEnd={buttonsColumnEnd}>
                {buttons}
                {itemCard}
            </EiaCard>
            <EiaCard
                columnStart={tableColumnStart}
                columnEnd="-1"
            >
                {heading ? <Heading>{heading}</Heading> : null}
                <Flex direction="row" justifyContent={overItemsLeftElements ? "space-between" : "flex-end"}>
                    {overItemsLeftElements}
                    {overItemsRightElements}
                </Flex>
                <EiaTable selectedRowId={selectedAuctionId} setSelectedRowId={setSelectedAuctionId}
                          isLoading={isLoading} data={tableData} tableHeader={tableHeader} initialState={tableInitialState} rowsPerPage={rowsPerPage}/>
            </EiaCard>
        </Grid>

    );
}
export default EiaAuctionTableWithButtons;